import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CourseComplettionComponent } from 'src/app/pages/individual/course-complettion/course-complettion.component';

@Injectable({
  providedIn: 'root'
})
export class CourseCompletionService {

  public examType!: string;
  public paramsData: any;
  public isAllSectionCompleted!: boolean;
  public isSetExam!: boolean;
  public subSectionData: any;

  constructor(public dialog: MatDialog, private router: Router) { }

  getNextId(secData: any, sectionArr: any[], paramsData: any, subSectionData: any) {

    let sectionId = secData.sectionId
    let subSectionId = secData.subSectionId
    this.examType = secData.examType
    this.isSetExam = secData.isSetExam
    this.isAllSectionCompleted = secData.isAllSectionCompleted
    this.paramsData = paramsData;
    if(subSectionData){
      this.subSectionData = subSectionData
    }
    let currentSectionIdIndex = sectionArr.findIndex(i => i.id == sectionId);
    //if sub section array is finishing then 
    if(!this.isAllSectionCompleted){
      if (currentSectionIdIndex + 1 <= sectionArr.length) {
        let currentSubSectionIndex = sectionArr[currentSectionIdIndex]["arr"].findIndex(i => i == subSectionId)
        //should not be last sub section
        //if last sub section then move to next section's first sub section
        if (sectionArr[currentSectionIdIndex]["arr"].length == currentSubSectionIndex + 1) {
          if (currentSectionIdIndex + 1 != sectionArr.length) {
            sectionId = sectionArr[currentSectionIdIndex + 1]["id"]
            subSectionId = sectionArr[currentSectionIdIndex + 1]["arr"][0]
            let sData = {
              sectionId: sectionId,
              subSectionId: subSectionId
            }
          }
          else {
            return this.courseCompleted()
          }
        }
        else {
          subSectionId = sectionArr[currentSectionIdIndex]["arr"][currentSubSectionIndex + 1]
        }
        let data = {
          c_i: this.paramsData["c_i"], //course id
          p_i: this.paramsData["p_i"], //purchase
          s_i: sectionId,//section
          s_si: subSectionId, //sub section
          p_si: this.paramsData["p_si"],                 //purchase course (Value : 1=> my course 0=> if any other course)
          c_t:this.paramsData["c_t"],
        }
        return data
      }
      else {
        this.courseCompleted()
      }
    }
    else{this.courseCompleted()}
   
  }

  courseCompleted() {
    //adding this as when modal open after completing the whole course then iframe is not viewed
    if(this.subSectionData){
      if (this.subSectionData.type == "iframe") {
        setTimeout(() => {
          if (this.subSectionData.type == "iframe") {
            const iframe: any = document.getElementById('iframe');
            iframe.src = this.subSectionData.data;
          }
        }, 1000)
      }
    }
  
    if (this.isAllSectionCompleted) {
      if (!this.isSetExam) {
        this.onModal("informational")
      }
      else if (this.isSetExam && this.examType == "final") {
        this.onModal("exam")
      }
      else if (this.isSetExam && this.examType != "final") {
        alert("overall exam is set ")
        this.onModal("exam")
      }
      else {
        alert("None of the condition is met")
      }
    }
    else {
      //still module are pending
      this.onModal("module")
    }
    //course completed
  }
  onModal(type: String) {
    let data = {
      api_type: type,
      purchase_id: parseInt(this.paramsData.p_i),
      course_id: parseInt(this.paramsData.c_i),
    }
    if (this.examType == 'final') {
      data["e_t"] = 'f'
    }
    else {
      data["e_t"] = 'o'
    }
    const dialogRef = this.dialog.open(CourseComplettionComponent, {
      data: data, maxWidth: '552px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { }
    });
  }
}
